import type { ShutdownTimeOption } from './menuPage.type';

export const SHUTDOWN_TIME_OPTION: Record<string, ShutdownTimeOption> = {
  DAILY: 'DAILY',
  CUSTOM: 'CUSTOM',
  PERMANENT: 'PERMANENT',
};

export const MIN_LENGTH_SEARCH_QUERY = 3;
